(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'CruiseBookingCabins',
	};

	var label_name           = 'cruisebookingcabins-';
	var ajax_loader          = null;
	var cabin_lookup_btn     = null;
	var cabin_lookup_field   = null;
	var cabin_searched_field = null;
	var valid_cabins_field   = null;
	var valid_cabins         = [];
	var flashing_interval;


	var x1, x2, y1, y2;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		ajax_loader          = $('.lookup-spinner');
		cabin_lookup_btn     = $('.cabin-lookup');
		cabin_lookup_field   = $('#' + label_name + 'cabin_lookup');
		cabin_searched_field = $('#' + label_name + 'cabin_lookup_searched');
		valid_cabins_field   = $('#' + label_name + 'valid_cabins');

		// disable the lookup field unless there's a value in it
		if (cabin_lookup_field.val() === '') {
			cabin_lookup_field.prop('disabled', true);
		}

		// do a cabin lookup
		cabin_lookup_btn.click(function onCabinLookupClick(event) {
			var cabin_code = cabin_lookup_field.val();

			event.preventDefault();

			if (cabin_code) {
				// attempting to search for a cabin that was already validated
				if (
					cabin_code === cabin_searched_field.val() ||
					$.inArray(cabin_code, valid_cabins) !== -1
				) {
					// set the searched cabin value, since it's a valid cabin
					if (cabin_searched_field.val() === '') {
						cabin_searched_field.val(cabin_code);
					}

					Adzuki.StatusMessage(null, 'The requested cabin is available.', 'Cabin Lookup');
				} else {
					cabinLookup(cabin_code);
				}
			} else {
				Adzuki.StatusMessage(null, 'Cabin Number must be provided.', 'Cabin Lookup');
			}
		});

		// doing a lookup when pressing enter on the keyboard
		$(window).keydown(function onWindowKeyDown(event) {
			if (
				event.keyCode === 13
				&& cabin_lookup_field.is(':focus')
				&& cabin_lookup_field.val() !== ''
			) {
				cabin_lookup_btn.trigger('click');
				event.preventDefault();
			}
		});

		// clear bed types, deck etc. when typing a new cabin
		cabin_lookup_field.keyup(function onCabinLookupKeyup(event) {
			var deck_image    = $('.deck-image');
			var view_deck_btn = deck_image.find('.deck-image-modal').first();

			$('.other-bed-type').addClass('hidden');
			$('.bed-types').removeClass('hidden').html('N/A');
			$('.deck').html('N/A');
			$('.cabin-location').html('N/A');

			view_deck_btn.addClass('hidden');
			view_deck_btn.detach();
			deck_image.html('N/A');
			deck_image.append(view_deck_btn);
		});

		$('.cabins .clickable-row').click(function rowClicked(event) {
			var cabin_row      = $(this);
			var bedtype_select = null;
			var bedtype_label  = null;
			var cabin_code     = String(cabin_row.data('code'));

			// don't select the radio if only clicking on the deck image modal
			if ($(event.target).hasClass(Adzuki.FaIcon.getIconStyleName('search'))) {
				return;
			}

			// if it's the lookup row, enable the lookup field
			if (cabin_row.hasClass('cabin-lookup-row')) {
				cabin_lookup_field.prop('disabled', false);
			}

			// show the bed type select (if available)
			bedtype_select = cabin_row.find('.bed-type-select').first();
			bedtype_label  = cabin_row.find('.bed-type-label').first();

			if (bedtype_select.length > 0) {
				// hide any other existing selects,
				// except the select for the cabin lookup
				$('.bed-type-label').removeClass('hidden');
				$('.bed-type-select').each(function onEachBedTypeSeleect(i, el) {
					if (!$(el).hasClass('other-bed-type')) {
						$(el).addClass('hidden');
					}
				});

				if (!bedtype_select.hasClass('other-bed-type')) {
					bedtype_select.removeClass('hidden');
					bedtype_label.addClass('hidden');
				}
			}

			$('.cabin-radio').each(function setChecked() {
				var cabin_value = $(this).val();

				if (cabin_value === cabin_code) {
					$(this).prop('checked', true);
				}
			});
		});

		$('#modalWindow').on('hide.bs.modal', function _silenceYouFools() {
			$("#modalWindow iframe").attr("src", '');
			$("#modalWindow audio").attr("src", '');
			$("#modalWindow video").attr("src", '');
			$('#modalWindow').find('.modal-body').html('<iframe frameborder="0"></iframe>');

			clearInterval(flashing_interval);

			x1 = '';
			x2 = '';
			y1 = '';
			y2 = '';
		});

		$('.deck-image-modal').on('click', function onDeckImageModalClick(event) {
			var canvas_id        = Math.floor(Math.random() * 100),
				canvas_container = '<canvas id="canvas-' + canvas_id + '" class="center-block"></canvas>',
				image_file       = $(this).data('deck-image'),
				cabin_number     = $(this).data('cabin-num'),
				canvas,
				ctx,
				deck;

			x1 = $(this).data('x1');
			x2 = $(this).data('x2');
			y1 = $(this).data('y1');
			y2 = $(this).data('y2');

			event.preventDefault();
			clearInterval(flashing_interval);

			canvas_container = '<h4>Selected Cabin: ' + cabin_number + '</h4>' + canvas_container;

			$('.modal-title').text($(this).data('deck-title'));
			$('.modal-body').html(canvas_container);

			$('.modal').on('shown.bs.modal', function _loadMap() {
				deck        = new Image();
				deck.src    = image_file;
				deck.onload = function _getDimensions() {
					canvas        = document.getElementById(String("canvas-" + canvas_id));
					ctx           = canvas.getContext("2d");
					canvas.width  = deck.width;
					canvas.height = deck.height;
					ctx.drawImage(deck, 0, 0);

					if (x1 !== '' && x2 !== '' && y1 !== '' && y2 !== '') {
						ctx.beginPath();
						ctx.lineWidth   = "6";
						ctx.strokeStyle = "#39AF49";
						ctx.rect(x1, y1, x2 - x1, y2 - y1);

						let counter = 0;

						flashing_interval = setInterval(function _strokeIt() {
							ctx.strokeStyle = (counter % 2 === 0) ? 'red' : '#39AF49';
							ctx.stroke();
							counter++;
						}, 1000);

						ctx.stroke();
					}
				};
			});

			$(".modal").off('click', '.deck-image-modal');
		});

		$('.select-button').click(function click(e) {
			$('#cruisebookingcabins-cabin').val($(this).data('cabin'));

			$(form.element).submit();
		});
	};

	function cabinLookup(cabin_code)
	{
		ajax_loader.removeClass('hidden');
		cabin_lookup_field.prop('disabled', true);

		Adzuki.Ajax.get('/CruiseBooking/lookupCabin/' + cabin_code)
		.then(function lookupCabinResponse(response) {
			var response_message = '';
			var cabin            = null;
			var deck_image       = $('.deck-image');
			var deck_image_url   = '';
			var deck_url_index   = null;
			var view_deck_btn    = deck_image.find('.deck-image-modal').first();

			ajax_loader.addClass('hidden');
			cabin_lookup_field.prop('disabled', false);

			if (response.return_value === 'complete') {
				response_message = 'The requested cabin is available.';
				cabin = response.cabin[0];

				if (cabin.cabinNumber) {
					cabin_searched_field.val(cabin.cabinNumber);
					valid_cabins.push(cabin.cabinNumber);
					valid_cabins_field.val(valid_cabins.join(','));
				}

				if (cabin.cabinBedType) {
					if (cabin.cabinBedType.length > 1) {
						$('.bed-types').addClass('hidden');
						$('.other-bed-type').empty().removeClass('hidden');

						$.each(cabin.cabinBedType, function eachCabinBedType(i, bed_type) {
							$('.other-bed-type').append($('<option>', {
								value: bed_type.bedTypeCode,
								text : bed_type.bedTypeName,
							}));
						});
					} else if (cabin.cabinBedType.length === 1) {
						$('.bed-types').html(cabin.cabinBedType[0].bedTypeName);
					} else {
						$('.bed-types').html('N/A');
					}
				}

				if (cabin.cabinDeckName) {
					$('.deck').html(cabin.cabinDeckName);
				}

				if (cabin.cabinLocation) {
					$('.cabin-location').html(cabin.cabinLocation[0]);
				}

				if (cabin.deckImageName) {
					view_deck_btn = view_deck_btn.detach();
					deck_image.html('').append(view_deck_btn);
					view_deck_btn.removeClass('hidden');
					deck_image_url = view_deck_btn.attr('data-deck-image');

					if (deck_image_url.indexOf('/decks/') >= 0) {
						deck_url_index = deck_image_url.indexOf('/decks/');
						view_deck_btn.data(
							'deck-image',
							deck_image_url.substr(0, deck_url_index) + '/decks/' + cabin.deckImageName + '/map.gif'
						);
						view_deck_btn.data('deck-title', cabin.deckImageName);
					}
				}
			} else {
				response_message = 'The Cabin Number provided is either unavailable or does not exist for this itinerary or cabin category. Please try entering a different Cabin Number.';

				cabin_searched_field.val('');
			}

			Adzuki.StatusMessage(null, response_message, 'Cabin Lookup');
		})
		.catch(function lookupCabinError(err) {
			ajax_loader.addClass('hidden');
			cabin_lookup_field.prop('disabled', false);
			cabin_searched_field.val('');

			Adzuki.StatusMessage(null, 'An error ocurred while looking up for the cabin, please try again.', 'Cabin Lookup');
		});
	}

}(jQuery, window.Adzuki || {}));
